import Box from '@mui/joy/Box'
import Button from '@mui/joy/Button'
import Typography from '@mui/joy/Typography'
import * as Sentry from '@sentry/react'
import { type FC, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useRouteError } from 'react-router-dom'

import { ErrorFallback } from './ErrorFallback'
import { isStaleChunkError } from './staleChunk'

const reloadPage = (): void => {
  location.reload()
}

const NewVersionNotice: FC<{ reload: () => void }> = ({ reload }) => {
  const { t } = useTranslation()

  return (
    <Box
      sx={{
        display: 'flex',
        width: '100%',
        height: '100%',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        gap: 1.5,
        textAlign: 'center',
        px: 2,
      }}
    >
      <Typography level="h2">{t('common.new-version.title')}</Typography>
      <Typography level="body-lg">{t('common.new-version.description')}</Typography>
      <Button onClick={reload}>{t('common.reload')}</Button>
    </Box>
  )
}

export const RouteErrorFallback: FC<{ reload?: () => void }> = ({ reload = reloadPage }) => {
  const error = useRouteError()
  const isStaleChunk = isStaleChunkError(error)

  useEffect(() => {
    if (!isStaleChunk) {
      Sentry.captureException(error)
    }
  }, [error, isStaleChunk])

  if (isStaleChunk) {
    return <NewVersionNotice reload={reload} />
  }

  return <ErrorFallback error={error instanceof Error ? error : undefined} />
}
